<template>
  <div class="templib-temp-use-item">
    <video muted="true" ref="currVideo" class="templib-video"></video>
    <!--:src="$handleAssetsUrl(sceneUI.videoUrl)"-->
    <div class="temp-use-cover" @click.self="itemClick" @mouseenter="preview" @mouseleave="stop">
      <el-checkbox v-model="sceneUI.selected" @change="updateCheckAll" class="ckb"></el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["sceneUI", "videoBlob"],
  methods: {
    updateCheckAll() {
      this.$emit("checkDisable");
    },
    itemClick(e) {
      this.sceneUI.selected = !this.sceneUI.selected;
      this.$emit("checkDisable");
    },
    preview() {
      let currVideo = this.$refs["currVideo"];
      currVideo.play();
      let to = null;
      let start = (this.sceneUI.startTime + 0.75) / 2;
      to = setTimeout(() => {
        currVideo.pause();
        currVideo.currentTime = start;
        clearTimeout(to);
        //console.log('to = setTimeout(() => {')
      }, this.sceneUI.scene.duration / 2 * 1000);
    },
    stop() {
      let curr = this.$refs["currVideo"];
      curr.pause();
      curr.currentTime = (this.sceneUI.startTime + 0.75) / 2;
    }
  },
  mounted() {
    let currVideo = this.$refs["currVideo"];
    currVideo.currentTime = (this.sceneUI.startTime + 0.75) / 2;
    if (this.videoBlob)
      currVideo.src = window.URL.createObjectURL(this.videoBlob);
    else currVideo.src = this.$handleAssetsUrl(sceneUI.videoUrl);

    //console.log('this.videoBlob',currVideo, this.videoBlob);
  }
};
</script>

<style lang="scss" scoped>
.templib-temp-use-item {
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  .templib-video {
    float: left;
    width: 100%;
    height: 100%;
  }
  .temp-use-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    .ckb {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/template/templateUseItem.vue